export const stringMapDefault = {
    back: "Back",
    viewNested: "View nested options"
};
